/**
 * 집계 차원 라벨 표시.
 *
 * 백엔드는 값이 없을 때 'Unknown', 리퍼러가 없을 때 'Direct',
 * 사설 IP 접속일 때 국가 'XX' / 도시 'Local' 을 내려준다.
 * 이런 내부 표기만 화면 언어로 옮기고,
 * 실제 값(국가 코드·도메인 등)은 그대로 둔다.
 */

type TranslateFn = (key: string) => string

const INTERNAL_LABELS: Record<string, string> = {
  unknown: 'analytics.unknown',
  direct: 'analytics.direct',
  // 사설 IP 접속에 대한 GeoIP 폴백값
  xx: 'analytics.localNetwork',
  local: 'analytics.localNetwork',
}

export function translateBreakdownLabel(label: string, t: TranslateFn): string {
  const normalized = label?.trim().toLowerCase()
  if (!normalized) {
    return t('analytics.unknown')
  }

  const key = INTERNAL_LABELS[normalized]
  return key ? t(key) : label
}

export default translateBreakdownLabel
